module.exports = __webpack_public_path__ + "img/Number=84.48761afa.png";